import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

import type { LoginFormFields } from "../schemes";
import { useRouter } from "@tanstack/react-router";
import { loginFn } from "../lib/authenticationFns";
import { setSession } from "../lib/authenticationClient";

const loginPayloadSchema = z.object({
	email: z.string(),
	password: z.string(),
});

const normalizeEmail = (username: string) => {
	const regex = /@.+\..+$/g;
	if (!regex.test(username)) {
		return `${username}@tecniphone.pt`;
	}

	return username;
};

const loginUser = async (data: LoginFormFields) => {
	const payload = loginPayloadSchema.parse({
		email: normalizeEmail(data.username),
		password: data.password,
	});

	return loginFn({ data: payload });
};

export const useLoginMutation = () => {
	const router = useRouter();

	return useMutation({
		mutationFn: loginUser,
		onSuccess: async (ctx) => {
			if (ctx.error) {
				return;
			}

			setSession(ctx);
			await router.invalidate();

			// TODO: redirect based on the user role
			router.navigate({ to: "/m/dashboard" });
		},
	});
};
